import { Container, ContainerProps, Paper } from "@mui/material";
import React from "react";
import Panel from "../Utility/Panel";

//給個panel? PanelContainer?
//PageContainer就要把md做完了
export function SimpleContainer(props: ContainerProps) {
  var defaultStyle: React.CSSProperties = { padding: 24 };
  const { maxWidth = "md", style, ...other } = props;
  Object.assign(defaultStyle, style);
  return (
    <Container maxWidth={maxWidth} style={defaultStyle} {...other}>
      <Panel>{props.children}</Panel>
    </Container>
  );
}
